'use strict';

module.exports = {
  apiHost: 'https://developer-api.aaecosystem.com',
};
